import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["className", "id", "value", "defaultValue", "onChange", "items", "inputProps", "IconComponent", "variant", "label", "helperText", "placeholder", "children", "renderValue", "required", "roundImages", "size", "margin", "multiple", "dividers", "underline"];
import React, { forwardRef, useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from 'tss-react/mui';
import { FormControl as MuiFormControl, InputLabel as MuiInputLabel, MenuItem as MuiMenuItem, Select as MuiSelect, ListSubheader as MuiListSubheader } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
// import Avatar from '../Avatar';
import Divider from '../Divider';
import Typography from '../Typography';
import useStyles from './Select.styles';

// TODO: Create validations
var Select = /*#__PURE__*/forwardRef(function (props, ref) {
  var className = props.className,
    id = props.id,
    value = props.value,
    defaultValue = props.defaultValue,
    onChange = props.onChange,
    items = props.items,
    inputProps = props.inputProps,
    IconComponent = props.IconComponent,
    variant = props.variant,
    label = props.label,
    helperText = props.helperText,
    placeholder = props.placeholder,
    children = props.children,
    renderValue = props.renderValue,
    required = props.required,
    roundImages = props.roundImages,
    size = props.size,
    margin = props.margin,
    multiple = props.multiple,
    dividers = props.dividers,
    underline = props.underline,
    other = _objectWithoutProperties(props, _excluded);
  var _useStyles = useStyles(),
    classes = _useStyles.classes,
    cx = _useStyles.cx;
  var _makeStyles = makeStyles()(function (theme) {
      return {
        large: {},
        medium: {
          '& label': {
            transform: 'translate(14px, 12px) scale(1)',
            '&.MuiFormLabel-filled': {
              transform: variant !== 'outlined' ? 'translate(4px, -6px) scale(0.75)' : null
            }
          },
          '& .MuiInputBase-formControl': {
            marginTop: 0
          },
          '& .MuiInputBase-input': {
            boxSizing: 'border-box',
            height: 40,
            padding: "".concat(theme.spacing(1), " ").concat(theme.spacing(3), " ").concat(theme.spacing(1), " ").concat(theme.spacing(1)),
            'label + &': {
              marginTop: theme.spacing(1)
            }
          }
        },
        small: {
          '& label': {
            transform: variant !== 'outlined' ? 'translate(10px, 10px) scale(1)' : 'translate(10px, 10px) scale(1)',
            '&.MuiFormLabel-filled': {
              transform: variant !== 'outlined' ? 'translate(4px, -6px) scale(0.75)' : null
            }
          },
          '& .MuiInputBase-formControl': {
            marginTop: 0
          },
          '& .MuiInputBase-input': {
            padding: "".concat(theme.spacing(1), " ").concat(theme.spacing(3), " ").concat(theme.spacing(1), " ").concat(theme.spacing(1)),
            'label + &': {
              marginTop: theme.spacing(1)
            }
          }
        }
      };
    })(),
    dynamicClasses = _makeStyles.classes;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    menuItems = _useState2[0],
    setMenuItems = _useState2[1];
  var inputLabel = useRef(null);
  useEffect(function () {
    var _menuItems = [];
    var renderOptions = function renderOptions(opts) {
      return opts.forEach(function (option, index) {
        if (option.divider) {
          _menuItems.push( /*#__PURE__*/React.createElement(Divider, {
            key: index
          }));
        } else if (option.group) {
          _menuItems.push( /*#__PURE__*/React.createElement(MuiListSubheader, {
            key: index
          }, option.name));
          renderOptions(option.group);
        } else {
          _menuItems.push( /*#__PURE__*/React.createElement(MuiMenuItem, {
            key: option.key || option.id || index + option.text,
            className: cx(classes.item),
            value: option.value
          }, option.image && /*#__PURE__*/React.createElement("img", {
            className: cx(classes.itemImage, option.imageClassName, _defineProperty({}, classes.roundImages, roundImages)),
            src: option.image,
            alt: option.imageName
          }), option.imageComponent, /*#__PURE__*/React.createElement(Typography, null, option.text)));
          if (dividers && index < items.length - 1) {
            _menuItems.push( /*#__PURE__*/React.createElement(Divider, {
              key: index
            }));
          }
        }
      });
    };
    if (items) {
      renderOptions(items);
    } else if (children) {
      _menuItems = children;
    }
    setMenuItems(_menuItems);
  }, [children, classes.item, classes.itemImage, classes.roundImages, dividers, items, roundImages]);
  var labelId = label === null || label === void 0 ? void 0 : label.toLowerCase().replaceAll(' ', '-');
  return /*#__PURE__*/React.createElement(MuiFormControl, _extends({
    className: cx(classes.root, dynamicClasses[size], {
      'MuiFormControl-marginDense': margin === 'dense'
    }, className),
    variant: variant,
    ref: ref
  }, other), label && /*#__PURE__*/React.createElement(MuiInputLabel, {
    className: cx(_defineProperty({}, classes.label, variant !== 'standard')),
    ref: inputLabel,
    id: labelId
  }, label), /*#__PURE__*/React.createElement(MuiSelect, {
    className: cx(classes.select, _defineProperty({}, classes.notUnderline, !underline && variant === 'standard')),
    labelId: labelId,
    onChange: onChange,
    value: value === undefined ? '' : value,
    defaultValue: defaultValue || '',
    multiple: multiple,
    label: label,
    id: id,
    renderValue: renderValue,
    inputProps: _extends({
      className: cx(inputProps.className, classes.innerInput)
    }, inputProps),
    IconComponent: IconComponent || ExpandMoreIcon,
    MenuProps: {
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'left'
      },
      transformOrigin: {
        vertical: 'top',
        horizontal: 'left'
      }
    }
  }, !required && placeholder && /*#__PURE__*/React.createElement(MuiMenuItem, {
    value: ""
  }, placeholder), menuItems));
});
process.env.NODE_ENV !== "production" ? Select.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool, PropTypes.array, PropTypes.object]),
  variant: PropTypes.oneOf(['standard', 'outlined', 'filled']),
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  margin: PropTypes.oneOf(['dense', 'normal']),
  onChange: PropTypes.func.isRequired,
  roundImages: PropTypes.bool,
  items: PropTypes.array,
  inputProps: PropTypes.object,
  IconComponent: PropTypes.element,
  multiple: PropTypes.bool,
  underline: PropTypes.bool
} : void 0;
Select.defaultProps = {
  variant: 'outlined',
  inputProps: {},
  multiple: false,
  roundImages: false,
  size: 'small',
  underline: true
};
export default Select;